import axios from 'axios';

export const API_URLS: Record<string, string> = {
    "dev-us": process.env.REACT_APP_DEV_API_URL!,
    "demo-us": process.env.REACT_APP_DEMO_API_URL!,
    "staging-us": process.env.REACT_APP_STAGING_API_URL!,
    "live-us": process.env.REACT_APP_LIVE_API_URL!,
    "dev-eu": process.env.REACT_APP_EU_DEV_API_URL!,
    "demo-eu": process.env.REACT_APP_EU_DEMO_API_URL!,
    "staging-eu": process.env.REACT_APP_EU_STAGING_API_URL!,
    "live-eu": process.env.REACT_APP_EU_LIVE_API_URL!,
};

export const createApiClient = (env: keyof typeof API_URLS = "dev-us") => {
    return axios.create({
        baseURL: API_URLS[env],
        timeout: 90000,
    });
};

